import { useState, useEffect } from 'react';

export const useCookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);
  
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const cookieAccepted = localStorage.getItem('cookieAccepted');
      
      if (!cookieAccepted) {
        setIsVisible(true);
      }
    }
  }, []);
  
  const acceptCookies = () => {
    if (typeof window !== 'undefined') {
      localStorage.setItem('cookieAccepted', 'true');
      setIsVisible(false);
    }
  };
  
  const dismissBanner = () => {
    acceptCookies();
  };

  return {
    isVisible,
    acceptCookies,
    dismissBanner
  };
};